// extracted by css-extract-rspack-plugin
export default {"cls1":"PostPrompt-cls1_2pj","cls2":"PostPrompt-cls2_z8T PostPrompt-cls1_2pj"};